<template>
  <section class="content">
    <template v-for="alert in alerts">
      <b-alert :show="alert.dismiss" dismissible :variant="alert.type">
        <h4>
          <i v-if="alert.type === 'success' || alert.type === 'warning' "class="icon fa fa-check"></i>
          <i class="icon fa fa-ban" v-else></i>
          {{`alert_${alert.type}` | translate}}!</h4>
        {{alert.message}}
      </b-alert>
    </template>
    <div class="row">
      <div class="col-xs-12">
        <multiselect v-model="company" :options="$store.getters.companies" placeholder="Select one" label="name" track-by="id"></multiselect>
      </div>
    </div>
    <hr>
    <div class="box box-primary">
      <div class="box-header with-border">
        <h3 class="box-title">{{'categories_selling_stats' | translate}}</h3>
        <div class="box-tools pull-right">
          <button type="button" class="btn btn-box-tool" data-widget="collapse">
            <i class="fa fa-minus"></i>
          </button>
        </div>
      </div>
      <div class="box-body">
        <div class="row">
          <div class="col-xs-3">
            <div class="form-group">
              <label for="ordertime" class="control-label">Zeitraum:</label>
              <date-range-picker :startDate="startRange" :endDate="endRange" id="ordertime" @pepe="onDateSelected"></date-range-picker>
            </div>
          </div>
          <div class="col-xs-9">
            <time-tabs :filter="filter" @select="handleTimeTab"></time-tabs>
          </div>
        </div>
        <div class="row mt-10">
          <channels-filter @selectedChannel="(val) => {salesChannel = val}"></channels-filter>
          <!--<div class="col-xs-12">
            <b-btn :pressed="salesChannel === 'all'" @click="salesChannel = 'all'" :class="['btn btn-info', salesChannel === 'all' ? 'bg-info' : '']">{{'all' | translate}}</b-btn>
            <button type="button" @click="salesChannel = 'schuhede'" :class="['btn btn-outline', salesChannel === 'schuhede' ? 'bg-white' : '']"><i class="fa fa-schuhe mr-5"/>Schuhe.de</button>
            <button type="button" @click="salesChannel = 'amazon'" :class="['btn btn-outline', salesChannel === 'amazon' ? 'bg-white' : '']"><i class="fa fa-amazon mr-5"/>Amazon</button>
            <button type="button" @click="salesChannel = 'zalando'" :class="['btn btn-outline', salesChannel === 'zalando' ? 'bg-white' : '']"><i class="fa fa-zalando mr-5"/>Zalando</button>
            <button type="button" @click="salesChannel = 'ebay'" :class="['btn btn-outline', salesChannel === 'ebay' ? 'bg-white' : '']"><i class="fa fa-ebay mr-5"/>eBay</button>
          </div>-->
        </div>
        <div class="row mt-10">
          <div class="col-xs-4">
            <span>Hauptkategorie:</span>
          </div>
          <div class="col-xs-3">
            <span>Sortieren nach:</span>
          </div>
        </div>
        <div class="row mt-10">
          <div class="col-xs-4">
            <button data-toggle="tooltip" title="Damenschuhe" type="button" @click="toggleMain('damenschuhe')" :class="['btn btn-outline',  mainCategory === 'damenschuhe' ? 'bg-white' : '']"><i class="fa fa-female fa-2x"/></button>
            <button data-toggle="tooltip" title="Herrenschuhe" type="button" @click="toggleMain('herrenschuhe')" :class="['btn btn-outline', mainCategory === 'herrenschuhe' ? 'bg-white' : '']"><i class="fa fa-male fa-2x"/></button>
            <button data-toggle="tooltip" title="Kinderschuhe" type="button" @click="toggleMain('kinderschuhe')" :class="['btn btn-outline', mainCategory === 'kinderschuhe' ? 'bg-white' : '']"><i class="fa fa-child fa-2x"/></button>
            <button data-toggle="tooltip" title="Accesoires" type="button" @click="toggleMain('mode-accesoires')" :class="['btn btn-outline', mainCategory === 'mode-accesoires' ? 'bg-white' : '']"><i class="fa fa-shopping-bag fa-2x"/></button>
            <button data-toggle="tooltip" title="Sportbedarf" type="button" @click="toggleMain('sportbedarf')" :class="['btn btn-outline', mainCategory === 'sportbedarf' ? 'bg-white' : '']"><i class="fa fa-soccer-ball-o fa-2x"/></button>
          </div>
          <div class="col-xs-3 pull-left">
            <button :class="['btn btn-outline', sort === 'asc' ? 'bg-white' : '']" @click="sort = sort === 'asc' ? false : 'asc' "><i class="fa fa-arrow-up fa-2x"></i></button><button @click="sort = sort === 'desc' ? false : 'desc' " :class="['btn btn-outline ml-5', sort === 'desc' ? 'bg-white' : '']"><i class="fa fa-arrow-down fa-2x"></i></button>
          </div>
        </div>
        <div class='row mt-10'>
          <div class="col-xs-3">
            <select class="form-control" :disabled="defaultCats || subcats.length === 0" v-model="selectedSubCat">
              <option v-if="!selectedSubCat" :value="false">Wählen Sie eine sub Kategorie</option>
              <option v-for="cat in subcats" :value="cat">{{formCatName(cat)}}</option>
            </select>
          </div>
          <div class="col-xs-3" v-if="selectedSubCat">
            <button type="button" @click="updateSubcats([mainCategory])" class="btn btn-warning"><i class="fa fa-trash-o mr-5"></i>Subkategorie löschen</button>
          </div>
        </div>
        <div class='row mt-10'>
          <div class="col-xs-12 mt-10">
            <div v-show="loading" class='text-center mt-10 mb-10'>
              <i class='fa fa-spinner fa-spin fa-5x'></i>
              <br/><span class='mt-10'>{{'loading' | translate}}...</span>
            </div>
            <categories-stats-chart v-show="!loading && !empty"
              @loading="loading = true"
              @finished="loading = false"
              @noData="empty = true"
              @yesData="empty = false"
              @updateSubcats="updateSubcats"
              :border="'#1ACA1A'"
              :rgbStyle="'0, 255, 0'"
              :title="'ecommerce'"
              :companies="company"
              :date="dateRange"
              :salesChannel="salesChannel"
              :sort="sort"
              :orderField="orderField"
              :categories="mainCategory"
              :subcat="selectedSubCat">
            </categories-stats-chart>
            <div v-show="empty && !loading" class="callout callout-info">
              <h4><i class="fa fa-exclamation-triangle mr-5"></i>Info</h4>
              <p>Es sind keine Stats vorhanden</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
	import VueMonthlyPicker from 'vue-monthly-picker'
	export default {
		data () {
			return {
			  defaultCats: true,
        selectedSubCat: false,
        mainCategory: 'all',
        loading: true,
        empty: false,
			  filter: window.localStorage.getItem('timeTabFilter') ? window.localStorage.getItem('timeTabFilter') : 'today',
        company: {id: 1, name: 'ANWR Media GmbH'},
        sort: '',
        orderField: false,
        salesChannel: 'all',
				alerts: [],
        startRange: moment().subtract(1, 'month'),
        endRange: moment(),
        subcats: [],
        dateRange: `${moment().format('YYYY-MM-DD')}#${moment().format('YYYY-MM-DD')}`
			}
		},
		components: {
			VueMonthlyPicker: VueMonthlyPicker
		},
		methods: {
		  formCatName (cat) {
		    return cat.split('-').map(c =>
		      this.$options.filters.capitalize(c)).join(' ')
      },
		  handleTimeTab (val) {
		    this.filter = val.filter
        this.startRange = moment(val.start)
        this.endRange = moment(val.end)
        this.dateRange = `${val.start}#${val.end}`
      },
      updateSubcats (val) {
        this.defaultCats = val.some(this.checkIfDefault)
		    if (this.defaultCats) {
          this.subcats = []
          this.selectedSubCat = false
        }
        else {
          this.subcats = val
          //this.selectedSubCat = false
        }
      },
      onDateSelected (picker) {
        this.dateRange = `${picker.startDate.format('YYYY-MM-DD')}#${picker.endDate.format('YYYY-MM-DD')}`
        this.startRange = picker.startDate
        this.endRange = picker.endDate
      },
      toggleMain (cat) {
        this.mainCategory = this.mainCategory === cat ? 'all' : cat
		    this.selectedSubCat = false

      },
      checkIfDefault (cat) {
		    return cat === 'herrenschuhe' || cat === 'damenschuhe' || cat === 'kinderschuhe' || cat === 'mode-accesoires' || cat === 'sportbedarf'
      }
		},
		mounted () {
		},
		watch: {
		}
	}
</script>
<style>
  .date-popover {
    overflow-x: hidden;
    overflow-y: hidden;
    outline: none;
    max-width: 350px;
    width: 100%;
    border-radius: 0 0 .28571429rem .28571429rem;
    box-shadow: 0 2px 3px 0 rgba(34,36,38,.15);
    background: #212228 !important;
    transition: opacity .1s ease;
    position: relative;
    margin: auto;
    z-index: 10;
    border: 1px solid;
    font-size: 1rem;
    font-weight: 200;
  }
  .picker .monthItem .item.active:hover{
    border-top: 1px solid;
    cursor: pointer;
    background-color: rgba(0,195,150,.4) !important;
    border-color: rgba(0,195,150,1) !important;

  }
</style>
<style scoped>
  .loading-gif {
    top: 43%;
    left: 39%;
    width: 23%;
    position: relative;
  }
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
  .multiselect::placeholder {
    color: #ffffff !important;
  }
</style>
<style>
  .multiselect, .multiselect__input, .multiselect__single {
    font-size: 14px !important;
    background: transparent !important;
    color: #ffffff !important;
  }
  .multiselect__tags {
    min-height: 40px;
    display: block;
    padding: 8px 40px 0 8px;
    border-radius: 0px !important;
    border: 1px solid rgba(255,255,255,.15);
    color: #ffffff;
    background: transparent !important;
    font-size: 14px;
  }
  .multiselect__content-wrapper {
    position: absolute;
    display: block;
    background: #212228;
    width: 100%;
    max-height: 240px;
    overflow: auto;
    border: 1px solid rgba(255,255,255,.15);
    border-top: none;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    z-index: 1;
    -webkit-overflow-scrolling: touch;
  }

</style>



// WEBPACK FOOTER //
// src/components/views/Ecommerce/Categories.vue